import React from "react";

import { SelectList } from "@common/selectList";
import { Props } from "./types";
import { Input } from "./input";
import { Search } from "./search";
import { Zones } from "./zones";
import styles from "./styles.scss";

function ProjectsSelection({
  filter,
  resource,
  placeholder = "",
  setFilter,
}: Props) {
  const [search, setSearch] = React.useState("");

  return (
    <SelectList rootClassName={styles.root} listClassName={styles.list}>
      {({ isOpen, select }) => ({
        input: (
          <Input placeholder={placeholder} filter={filter} isOpen={isOpen} />
        ),
        list: (
          <div className={styles.projectsSelection}>
            <div className={styles.search}>
              <Search search={search} setSearch={setSearch} />
            </div>
            <Zones
              search={search}
              filter={filter.projects}
              setFilter={(projects) => setFilter({ ...filter, projects })}
              isOpen={true}
            />
          </div>
        ),
      })}
    </SelectList>
  );
}

export { ProjectsSelection };
